import { useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import { useEffect, useState } from "react";
import KahaLoader from "./components/loader/KahaLoader";
import MainRoute from "./navigation/MainRoute";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import NetworkStatusIndicator from "./components/NetworkStatusIndicator";
import { fetchBusinessById } from './domain/useCases/Business/fetchBusinessById.js';
import { useNetworkStatus } from './hooks/useNetworkStatus';

function App() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  
  // Monitor network status and handle image reloading
  const { isOnline } = useNetworkStatus();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");

    if (!id) {
      setLoading(false);
      return;
    }

    fetchBusinessById(id, {
      headers: {
        viewtype: "SAMPADA",
        platform: "WEB",
      },
    })
      .then((data) => {
        if (String(data.entity).toLowerCase() === "sampada" || String(data.entity).toLowerCase() === "tourist place") {
          const tag = data.tag;
          window.location.href = `https://sampada.kaha.com.np/${tag}`;
        } else {
          // Redirect to entity profile page for non-Sampada entities
          const tag = data.tag || id;
          navigate(`/entity/${tag}`);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <KahaLoader />;
  }

  return (
    <>
      <NetworkStatusIndicator />
      <MainRoute />
      <PWAInstallPrompt />
    </>
  );
}

export default App;
